declare global {
  interface Window {
    FB?: {
      init: (config: {
        appId: string;
        cookie: boolean;
        xfbml: boolean;
        version: string;
      }) => void;
      login: (
        callback: (response: {
          authResponse?: { code?: string } | null;
        }) => void,
        options: {
          config_id: string;
          response_type: string;
          override_default_response_type: boolean;
          extras?: {
            setup?: Record<string, unknown>;
            featureType?: string;
            sessionInfoVersion?: number;
          };
        }
      ) => void;
    };
    fbAsyncInit?: () => void;
  }
}

export const loadFacebookSDK = (
  appId: string,
  version = 'v21.0'
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      window.FB.init({
        appId,
        cookie: true,
        xfbml: true,
        version,
      });
      resolve();
      return;
    }

    window.fbAsyncInit = function () {
      if (window.FB) {
        window.FB.init({
          appId,
          cookie: true,
          xfbml: true,
          version,
        });
        resolve();
      } else {
        reject(new Error('Facebook SDK failed to load'));
      }
    };

    (function (d, s, id) {
      const existingScript = d.getElementById(id);
      if (existingScript) {
        return;
      }

      const js = d.getElementsByTagName(s)[0];
      const fjs = d.createElement(s) as HTMLScriptElement;
      fjs.id = id;
      fjs.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.async = true;
      fjs.onerror = () => {
        reject(new Error('Failed to load Facebook SDK script'));
      };

      if (js && js.parentNode) {
        js.parentNode.insertBefore(fjs, js);
      } else {
        d.head.appendChild(fjs);
      }
    })(document, 'script', 'facebook-jssdk');

    setTimeout(() => {
      if (!window.FB) {
        reject(new Error('Facebook SDK loading timeout'));
      }
    }, 10000);
  });
};
